import { Injectable } from '@angular/core';
import { IParticipant } from '@interfaces/interfaces';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { getActiveParticipant } from 'src/app/store/reducers';
import * as SettingsActions from '../../store/settings/actions';
import { firstValueFrom } from '@app/util/rxjs-7-compat';

@Injectable({
	providedIn: 'root'
})
export class ActiveParticipantService {
	private _participant$: Observable<IParticipant>;

	constructor(
		private store: Store,
	) {
		this._participant$ = this.store.select(getActiveParticipant).pipe(
			filter(participant => participant !== undefined)
		);
	}

	get participant$(): Observable<IParticipant> {
		return this._participant$;
	}

	public set activeParticipant({id: participantId}: Pick<IParticipant, 'id'>) {
		this.store.dispatch(SettingsActions.activeParticipantChange({ activeParticipantID: participantId || null}));
	}
	
	public async refreshParticipant(): Promise<void> {
		this.activeParticipant = await firstValueFrom(this._participant$);
	}
}
